<script>
/**
 * ****************************************************************************
 * @description     :   Switch Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';
import { validatePhoneNumber, validateMobilePhoneNumber } from '@/utils/phoneValidator';

/**
 * Define content of switch component
 */
var AnsSwitch = {
    template: template,
    props: {
        id: String,
        label: String,
        style: String,
        itemClass: {
            type: String,
            default: 'col-md-7 col-sm-12'
        },
        buttonClass: String,
        buttonSecondClass: String,
        labelClass: String,
        labelBefore: String,
        labelAfter: String,
        inputClass: String,
        placeholder: String,
        value: String,
        modelValue: String | Number,
        isRequired: Boolean,
        isDisabled: Boolean,
        isDisabledIcon: Boolean,
        isDisabledSecondIcon: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        type: String,
        isDecimal: {
            type: Boolean,
            default: false
        },
        isDisableIME: {
            type: Boolean,
            default: false
        },
        decimal: Number,
        isNegative: Boolean,
        isNotShowCurrency: Boolean,
        maxLength: Number,
        cols: Number,
        rows: Number,
        icon: String,
        secondIcon: String,
        isInputGroup: Boolean,
        isSecondInputGroup: Boolean,
        onChange: Function,
        onFocus: Function,
        onBlur: Function,
        onClick: Function,
        onSecondClick: Function,
        isStartWithZero: {
            type: Boolean,
            default: true
        },
        isUppercase: {
            type: Boolean,
            default: false
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        appendBtn: {
            type: String,
            default: ''
        },
        labelAfterClass: {
            type: String,
            default: ''
        },
        inputGroupClass: {
            type: String,
            default: ''
        },
        errors: {
            type: Array
        },
        format344: {
            type: Boolean,
            default: false
        },
        isAutocomplete: {
            type: Boolean,
            default: false
        },
        isShowErrorFormat: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            input1: '',
            input1_old: '',
            input2: '',
            input2_old: '',
            input3: '',
            input3_old: '',
            fullInput: '',
            isFocus: false,
            realMaxLength: undefined,
            modeDisabled: false,
            err_format: false
        };
    },
    mounted() {
        this.initData();
        this.realMaxLength = this.getRealMaxLength();
        this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
    },
    watch: {
        isDisabled(val) {
            val ? (this.err_format = false) : this.err_format;
        },
        input1(val) {
            if (!this.isDisabled) {
                if (this.format344 && val.length < 3) {
                    this.err_format = true;
                } else {
                    this.err_format = false;
                }
            }

            if (val) {
                this.fullInput = this.input1 + '-' + this.input2 + '-' + this.input3;
            } else {
                this.fullInput = '-' + this.input2 + '-' + this.input3;
            }
        },
        input2(val) {
            if (!this.isDisabled) {
                if (this.format344 && val.length < 4) {
                    this.err_format = true;
                } else {
                    this.err_format = false;
                }
            }
            if (val) {
                this.fullInput = this.input1 + '-' + this.input2 + '-' + this.input3;
            } else {
                this.fullInput = this.input1 + '-' + '-' + this.input3;
            }
        },
        input3(val) {
            if (!this.isDisabled) {
                if (this.format344 && val.length < 4) {
                    this.err_format = true;
                } else {
                    this.err_format = false;
                }
            }
            if (val) {
                this.fullInput = this.input1 + '-' + this.input2 + '-' + this.input3;
            } else {
                this.fullInput = this.input1 + '-' + this.input2 + '-';
            }
        },
        fullInput(val) {
            if (!this.isDisabled) {
                let inputFull = val.replace(/-/g, '');
                if (inputFull != '') {
                    const val_full = val.split('-');
                    let val_1 = val_full[0] ?? '';
                    let val_2 = val_full[1] ?? '';
                    let val_3 = val_full[2] ?? '';
                    if (
                        (this.format344 && !validateMobilePhoneNumber(val_1, val_2, val_3)) ||
                        (!this.format344 && !validatePhoneNumber(val_1, val_2, val_3)) ||
                        val_1 == '' ||
                        val_2 == '' ||
                        val_3 == ''
                    ) {
                        this.err_format = true;
                    } else {
                        this.err_format = false;
                    }
                } else {
                    this.err_format = false;
                }
            }
            if (val) {
                this.$emit('update:modelValue', val);
            }
        },
        // fullInput(val) {
        //     const check = val.split('-').includes('');
        //     let inputFull = val.replace(/-/g, '');
        //     if (inputFull != '') {
        //         if (check == false) {
        //             this.$emit('update:modelValue', val);
        //         } else {
        //             this.input1 = this.input1_old;
        //             this.input2 = this.input2_old;
        //             this.input3 = this.input3_old;
        //             this.$emit('update:modelValue', val);
        //         }
        //     } else {
        //         this.$emit('update:modelValue', '');
        //         this.input1 = '';
        //         this.input2 = '';
        //         this.input3 = '';
        //         this.input1_old = '';
        //         this.input2_old = '';
        //         this.input3_old = '';
        //     }
        // },
        modelValue(val) {
            if (!val && this.input1 && this.input2 && this.input3) {
                this.input1 = '';
                this.input2 = '';
                this.input3 = '';
            } else {
                if (this.modelValue != undefined) {
                    const data = this.modelValue.split('-');
                    this.input1 = data[0] ?? '';
                    this.input2 = data[1] ?? '';
                    this.input3 = data[2] ?? '';
                }
            }
        }
    },
    computed: {
        vewValue: {
            get() {
                let val = this.convertNumber(this.modelValue ? this.modelValue : this.value);
                if (this.isFocus && !this.isDisabled && !this.isReadonly) {
                    if (this.type == 'money') {
                        val = val.replace(/¥/g, '');
                    }
                    // eslint-disable-next-line prettier/prettier
                    return this.type == 'money' ||
                        (this.type == 'measure' && !this.isDecimal)
                        ? val.replace(/,/g, '')
                        : this.type == 'postcode'
                        ? val.replace(/-/g, '')
                        : val;
                }
                return val;
            },
            set() {}
        },
        validateError() {
            let message = '';
            if (this.errors) {
                this.errors.forEach((item) => {
                    if (item.name == this.id) {
                        message = item.message;
                    }
                });
            }
            return message;
        },
        fullPhone() {
            if (this.format344) {
                return validateMobilePhoneNumber(this.input1, this.input2, this.input3);
            } else {
                return validatePhoneNumber(this.input1, this.input2, this.input3);
            }
        }
    },
    methods: {
        initData() {
            if (this.modelValue && !this.input1 && !this.input2 && !this.input3) {
                const data = this.modelValue.split('-');
                this.input1 = data[0] ?? '';
                this.input2 = data[1] ?? '';
                this.input3 = data[2] ?? '';
            }
        },
        /**
         * convert number type for input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        convertNumber(value) {
            if (value == undefined || value == '' || value == null) {
                return '';
            }
            value = value + '';
            let values = [];
            let negative = '';
            let dot = '';
            let afterDot = '';
            if (this.type == 'number' || this.type == 'money' || this.type == 'measure') {
                if (this.isDecimal) {
                    this.realMaxLength = this.maxLength + 1;
                }

                if (this.isNegative && value.startsWith('-')) {
                    negative = '-';
                }
                values = value.split('.');
                values[0] = values[0].replace(/\D/g, '');

                if (values.length > 1) {
                    afterDot = values[1].replace(/\D/g, '');
                    if (afterDot.length > this.decimal) {
                        afterDot = afterDot.substring(0, this.decimal);
                    }
                    dot = '.';
                    this.isDecimal ? (value = negative + values[0] + dot + afterDot) : (value = negative + values[0]);
                }

                if (this.type == 'measure' && !this.isDecimal) {
                    values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    value = negative + values[0];
                }

                if (this.type == 'money') {
                    values[0] = values[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    values[0] = values[0].replace(/^0+/, '');
                    if (values[0]) {
                        value = negative + (this.isNotShowCurrency ? '' : '¥') + values[0] + (values.length > 1 ? '.' + values[1] : '');
                    } else {
                        value = negative + (this.isNotShowCurrency ? '' : '¥') + values[0] + (values.length > 1 ? '.' + values[1] : '0');
                    }
                }
                // author: trinhdtk - ANS845
                // if type is number, and not allow start with zero
                // Eg: 0123 => 123
                if (this.type == 'number' && !this.isStartWithZero) {
                    values[0] = values[0].replace(/^0+/, '');
                    value = values[0];
                }

                if (this.isDecimal && this.decimal > 0 && afterDot === '' && value.length > this.maxLength - this.decimal) {
                    dot = '.';
                    afterDot = values[0].substring(this.maxLength - this.decimal, value.length);
                    values[0] = values[0].substring(0, this.maxLength - this.decimal);
                    this.isDecimal ? (value = negative + values[0] + dot + afterDot) : (value = negative + values[0]);
                }

                if (!values[0]) {
                    values[0] = 0;
                }
            }

            if (this.type == 'postcode') {
                const postcode = value.replace(/\D/g, '');
                if (postcode.length >= 7) {
                    value = postcode.slice(0, 3) + '-' + postcode.slice(3, 7);
                } else {
                    value = '';
                }
            }
            return value;
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        getRealMaxLength(e) {
            if (this.maxLength == undefined || this.maxLength == null || this.type != 'money' || this.type != 'measure') {
                let maxLength = this.maxLength;
                if (e) {
                    if (this.type == 'number') {
                        if (e.target.value.indexOf('-') >= 0) {
                            maxLength += 1;
                        }
                        if (e.target.value.indexOf('.') >= 0) {
                            maxLength += 1;
                        }
                    }
                    if (this.type == 'postcode') {
                        if (e.target.value.indexOf('-') >= 0) {
                            maxLength += 1;
                        }
                    }
                }
                return maxLength;
            }
            return this.maxLength + (parseInt(this.maxLength / 3) + (this.maxLength % 3 > 0 ? 0 : -1));
        },
        /**
         * event forcus on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            //e.target.select();
            this.isFocus = true;
            this.realMaxLength = this.maxLength;
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            if (e.target.value && !helpers.checkNotIMECharacter(e.target.value)) {
                e.target.value = '';
            }
            this.isFocus = false;
            this.realMaxLength = this.getRealMaxLength(e);
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * event keydown on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputKeydown(e) {
            if (this.type == 'number') {
                return this.inputOnlyNumber(e);
            }
        },
        inputKeyup(e) {
            let maxLength = this.maxLength;
            if (this.type == 'number') {
                if (e.target.value.indexOf('-') >= 0) {
                    maxLength += 1;
                }
                if (e.target.value.indexOf('.') >= 0) {
                    maxLength += 1;
                }
            }
            this.realMaxLength = maxLength;
            return true;
        },
        /**
         * event block key on input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        inputOnlyNumber(e) {
            if (
                !(
                    (e.keyCode > 47 && e.keyCode < 58) ||
                    (e.keyCode > 95 && e.keyCode < 106) ||
                    e.keyCode == 116 ||
                    e.keyCode == 46 ||
                    e.keyCode == 37 ||
                    e.keyCode == 39 ||
                    e.keyCode == 35 ||
                    e.keyCode == 36 ||
                    e.keyCode == 8 ||
                    e.keyCode == 9 ||
                    e.ctrlKey ||
                    e.keyCode == 229 ||
                    e.keyCode == 13
                ) ||
                (!this.isNegative && e.keyCode == 189) ||
                e.keyCode == 109
            ) {
                event.preventDefault();
                return false;
            }
            return true;
        },
        /**
         * update input
         * -----------------------------------------
         * @author : PhuongDT - 2024/05/22 - create
         * @params :
         * @access : private
         */
        updateInput(e, refInput) {
            const val = this.convertNumber(this?.$refs[refInput].value);
            let value = this.type == 'money' ? val.replace(/,/g, '') : val;
            if (this.type == 'money' || this.type == 'number') {
                const regex = this.isDecimal ? /([^0-9/.])/g : /[^0-9]/g;
                value = value.replace(regex, '');
            }
            if (refInput == `${this.id}-input1`) {
                this.input1 = value;
                this.input1_old = value;
            } else if (refInput == `${this.id}-input2`) {
                this.input2 = value;
                this.input2_old = value;
            } else if (refInput == `${this.id}-input3`) {
                this.input3 = value;
                this.input3_old = value;
            }
            //this.$emit('update:modelValue', value);
            if (this.onChange) {
                this.onChange(e, value);
                helpers.handleAddRemoveClass([
                    {
                        ele: e.target,
                        arrAddRemove: ['require-input'],
                        type: 0
                    }
                ]);
            }
        }
    }
};
export default AnsSwitch;
</script>
